import { Component } from 'react'
import { Icons, Box } from 'stylewhere/components'
import { OperationEncodingTagType } from 'stylewhere/types'

interface Props {
  started: boolean
  tagType?: OperationEncodingTagType
  ml?: number
}

export class AntennaStatus extends Component<Props> {
  render() {
    const { started, ml, tagType } = this.props
    let AntennaIconOn = Icons.AntennaOn
    if (tagType === 'UHF') {
      AntennaIconOn = Icons.AntennaOnRfid
    }
    if (tagType === 'NFC') {
      AntennaIconOn = Icons.AntennaOnNfc
    }
    return (
      <Box vcenter ml={15} width={77} center bg="#FFFFFF" borderRadius={10}>
        {started ? (
          <AntennaIconOn style={{ height: 40, width: 60, marginLeft: ml || 0 }} />
        ) : (
          <Icons.Antenna style={{ height: 35, width: 60, marginLeft: ml || 0 }} />
        )}
      </Box>
    )
  }
}
